import React from "react"
import LazyLoad from "react-lazyload"

import { Asset, Button, Decorator, IconButton, RichText } from "components"

function HomeHero({
  heroButtons,
  heroContent,
  heroDecorators,
  heroHeading,
  heroImage,
  heroVideo,
}) {
  if (heroHeading)
    return (
      <section className="relative pt-40 wrapper lg:pt-24 default-grid">
        {heroDecorators && heroDecorators[0] && (
          <Decorator
            className="absolute top-0 left-0 -translate-x-4 select-none lg:-translate-x-1/2"
            asset={heroDecorators && heroDecorators[0].asset}
            size="small"
          />
        )}
        {(heroImage || heroVideo) && (
          <div className="col-span-full lg:col-span-6">
            <div className="relative -mx-6 lg:ml-0 sm:-mx-fluidMargin xl:-mr-26">
              <div className="aspect-w-1 aspect-h-1">
                {heroImage && (
                  <Asset
                    asset={heroImage}
                    objectFit="cover"
                    objectPosition="center"
                    style={{ position: "absolute" }}
                  />
                )}
                {heroVideo && (
                  <LazyLoad
                    classNamePrefix="absolute top-0 bottom-0 left-0 right-0 w-full h-full"
                    once
                  >
                    <Asset
                      className="absolute top-0 bottom-0 left-0 right-0 object-cover object-center w-full h-full"
                      asset={heroVideo}
                    />
                  </LazyLoad>
                )}
                {heroDecorators && heroDecorators[1] && (
                  <div className="absolute bottom-0 left-0 w-32 h-32">
                    <Decorator asset={heroDecorators[1].asset} size="small" />
                  </div>
                )}
                <div>
                  <div
                    className="absolute bottom-0 right-0 w-px h-full origin-left transform translate-x-px translate-y-8 bg-mineralGray"
                    style={{ height: "calc(100% + 64px)" }}
                  />
                  <div
                    className="absolute bottom-0 right-0 h-px origin-left transform translate-y-1/2 translate-x-18 bg-mineralGray"
                    style={{ width: "calc(25% + 72px)" }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="relative order-first col-span-full lg:col-span-6">
          <div className="space-y-8 md:space-y-10">
            {heroHeading && (
              <h1 className="h1 text-darkPurple">{heroHeading}</h1>
            )}
            {heroContent && <RichText content={heroContent} size="large" />}
            <div>
              <div className="flex flex-wrap items-center -m-3 md:-m-4 md:flex-nowrap">
                {heroButtons && heroButtons[0]?.link?.link && (
                  <div className="p-3 md:p-4">
                    <Button
                      label={heroButtons[0]?.label}
                      href={heroButtons[0]?.link?.link}
                    />
                  </div>
                )}
                {heroButtons && heroButtons[1]?.link?.link && (
                  <div className="p-3 md:p-4">
                    <IconButton
                      label={heroButtons[1]?.label}
                      href={heroButtons[1]?.link?.link}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  else return null
}

export default HomeHero
